import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const poPdfCreateSlice = createApi({
    reducerPath: "poPdfCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        poPdfCreate: builder.query({
            query: (data) => ({ url: "/inventory/api/v1/purchase_order/get_pdf", params: data, method: "GET" }),
        }),
    }),
});

export const { usePoPdfCreateQuery } = poPdfCreateSlice;
